import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { Route, HashRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import Footer from './components/Footer/Footer';
import Navbar from './components/Navbar/Navbar';
import AboutMe from './Pages/AboutMe/AboutMe';
import Career from './Pages/Career/Career';
import Certificates from './Pages/Certificates/Certificates';
import Contact from './Pages/Contact/Contact';
import Education from './Pages/Education/Education';
import Projects from './Pages/Projects/Projects';
import TechStack from './Pages/TechStack/TechStack';
import './style.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<AboutMe />} />
          <Route path="/Education" element={<Education />} />
          <Route path="/Career" element={<Career />} />
          <Route path="/Certificates&Licences" element={<Certificates />} />
          <Route path="/TechStack" element={<TechStack />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
